import React from 'react';
import styles from './GlobalLoadingOverlay.module.css';

const BAR_COUNT = 12;

const GlobalLoadingOverlay: React.FC = () => {
  return (
    <div className={styles.overlay} role="status" aria-live="polite" aria-label="טוען">
      <div className={styles.spinner} aria-hidden>
        {Array.from({ length: BAR_COUNT }).map((_, index) => (
          <span
            key={index}
            className={styles.bar}
            style={{
              transform: `rotate(${index * 30}deg)`,
              animationDelay: `${-1 + index * (1 / BAR_COUNT)}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default GlobalLoadingOverlay;
